import type { IconName } from "@/lib/types";

export function Icon({ name, size = 22 }: { name: IconName; size?: number }) {
  const common = { width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.7, strokeLinecap: "round" as const, strokeLinejoin: "round" as const, "aria-hidden": true };

  const paths: Record<IconName, React.ReactNode> = {
    document: <><path d="M6 3.5h8l4 4v13H6z"/><path d="M14 3.5v4h4M9 12h6M9 16h6"/></>,
    knowledge: <><path d="M4 5.5c3-1 5-.6 8 1.4v13c-3-2-5-2.4-8-1.4z"/><path d="M20 5.5c-3-1-5-.6-8 1.4v13c3-2 5-2.4 8-1.4z"/></>,
    message: <><path d="M4 5h16v11H9l-5 4z"/><path d="M8 9h8M8 12.5h5"/></>,
    workflow: <><rect x="3" y="4" width="6" height="5" rx="1"/><rect x="15" y="15" width="6" height="5" rx="1"/><path d="M9 6.5h4a3 3 0 0 1 3 3v5.5M13 13l3 3 3-3"/></>,
    speed: <><path d="M5 17a8 8 0 1 1 14 0"/><path d="m12 13 4-4M4 20h16"/></>,
    people: <><circle cx="9" cy="8" r="3"/><path d="M3.5 19c.5-4 2.5-6 5.5-6s5 2 5.5 6M16 6.5a2.5 2.5 0 0 1 0 5M16.5 14c2.2.5 3.5 2.2 4 5"/></>,
    chart: <><path d="M4 20V10M10 20V4M16 20v-7M22 20V7M2 20h21"/></>,
    shield: <><path d="M12 3 20 6v5c0 5-3 8-8 10-5-2-8-5-8-10V6z"/><path d="m8.5 12 2.2 2.2 4.8-5"/></>,
    school: <><path d="m3 9 9-5 9 5-9 5zM6 11.5V18h12v-6.5M9 14v4M15 14v4"/></>,
    building: <><path d="M5 21V5l7-2v18M12 8h7v13M8 8h1M8 12h1M8 16h1M15 11h1M15 15h1"/></>,
    shop: <><path d="M4 10v10h16V10M3 10l2-6h14l2 6M8 10v10M16 10v4h-4v-4"/></>,
    property: <><path d="m3 11 9-8 9 8M5.5 9v11h13V9M9 20v-6h6v6"/></>,
    truck: <><path d="M3 6h11v11H3zM14 10h4l3 3v4h-7z"/><circle cx="7" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></>,
    spark: <><path d="m12 2 1.6 6.4L20 10l-6.4 1.6L12 18l-1.6-6.4L4 10l6.4-1.6z"/><path d="m19 16 .7 2.3L22 19l-2.3.7L19 22l-.7-2.3L16 19l2.3-.7z"/></>,
  };

  return <svg {...common}>{paths[name]}</svg>;
}

